module.exports = require('./middleware');
